import { mouseFollowWhenVisible } from "../utilities/mouse-follow";
import { get, getAll } from "../utilities/querySelector";

getAll( '.testimonials' ).forEach( section => {
    mouseFollowWhenVisible( section );

    const slider = get( '[data-testimonials-slider]', section );
    const nextArrow = get( '[data-testimonials-next]', section );
    const prevArrow = get( '[data-testimonials-prev]', section );
    jQuery( slider ).slick( {
        fade: true,
        nextArrow,
        prevArrow
    })
})